import React, { useEffect, useState } from 'react';
import {
  Grid,
  InputAdornment,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';

import { useAppSelector } from '../../../../../hooks';
import { TP_COLORS } from '../../../../../constants';
import { gridTitleProps, searchFieldProps } from '../modals/AddSubjectModal';
import { TPTextField } from '../../../../../components/Inputs';

import {
  getSubjectState,
  ISubject,
} from '../../../../../store/V2/SubjectSlice';

interface SelectSubjectProps {
  selectedSubject: ISubject | null;
  handleSubjectClick: (subjectItem: ISubject) => void;
}

const SelectSubject: React.FC<SelectSubjectProps> = ({
  selectedSubject,
  handleSubjectClick,
}) => {
  // Store
  const subjectState = useAppSelector(getSubjectState);

  const { list } = subjectState;

  // State
  const [subjectList, setSubjectList] = useState<ISubject[]>([]);

  useEffect(() => {
    setSubjectList(list);
  }, [list]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    setSubjectList(
      list.filter((subjectItem) =>
        subjectItem.subject.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  return (
    <Grid item xs={12} sm={4}>
      <Typography {...gridTitleProps}>Subjects</Typography>
      <TPTextField
        {...searchFieldProps}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        onChange={handleInputChange}
      />

      <List
        sx={{
          overflow: 'auto',
          height: { md: '370px' },
        }}
      >
        {subjectList.map((subjectItem, index) => {
          return (
            <ListItemButton
              key={index}
              selected={selectedSubject === subjectItem}
              onClick={() => handleSubjectClick(subjectItem)}
            >
              <ListItemText
                primary={subjectItem.subject}
                primaryTypographyProps={{
                  variant: 'subtitle2',
                  className: 'ellipsis-text',
                  color: TP_COLORS.gray.darken,
                }}
              />
            </ListItemButton>
          );
        })}
      </List>
    </Grid>
  );
};

export default SelectSubject;
